import React from 'react';
import calculateStudentGradeLevel from '../../../utilities/calculate-student-grade-label';

export const CandidateName = ({ student }) => {
    const gradeLevel = calculateStudentGradeLevel(student.gradYear);
    return (
        <div>
            {student.firstName} {student.lastName} - {gradeLevel}
        </div>
    );
};
